<template>
  <div class>
    <toptitle :title="topTitle" :subtitle="topSubTitle"></toptitle>
    <div class="products-container">
      <div class="container">
        <div class="row d-flex">
          <leftsidebar class="order-md-1 order-2" :isNews="true"></leftsidebar>
          <div class="products-box col-md-9 order-md-2 order-1">
            <div class="products-title">
              <span>全部新闻</span>
            </div>
            <div class="row">
              <ul class="news-box col-12">
                <router-link tag="li" class="news-items" v-for="(newsData, index) in News" :key="index" :to="`/newscontent/${newsData._id}`">
                  <i class="news-icon iconfont icon-jiantouarrowheads3"></i>
                  <a href class="news-link text-ellipsis">{{newsData.title}}</a>
                  <span class="news-date">{{newsData.date}}</span>
                </router-link>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      topTitle: '新闻中心',
      topSubTitle: '专业专注 · 用心服务',
      News: []
    }
  },
  methods: {
    // 获取新闻列表
    findNews: async function() {
      const res = await this.$http.get('/news')
      this.News = res.data
    }
  },
  created() {
    // this.findNews()
  }
}
</script>
<style scoped>
.products-container {
  padding: 30px 0;
}
.products-box {
  margin-bottom: 26px;
}
.products-title {
  border-bottom: 1px solid #cccccc;
  margin-bottom: 6px;
}
.products-title span {
  display: inline-block;
  font-size: 22px;
  padding: 4px 0;
  position: relative;
  bottom: -1px;
  border-bottom: 1px solid #048bd4;
  color: #048bd4;
}
.news-items {
  padding: 12px 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f2f2f2;
}

.news-link {
  width: 100%;
  margin-top: 1px;
  color: #999;
}
.news-items:hover *{
  color: #048bd4;
}

.news-icon {
  display: inline-block;
  transform: rotate(180deg);
  margin-left: -1px;
  margin-right: 8px;
  flex: 1;
  color: #048bd4;
}

.news-date {
  display: inline-block;
  text-align: right;
  width: 120px;
  font-size: 14px;
  color: #999;
  margin-top: 1px;
}
</style>